module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBmaWxsPSJub25lIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48Zz48cmVjdCB4PSIwLjc1IiB5PSIwLjc1IiB3aWR0aD0iMTQuNTAwMDAxOTA3MzQ4NjMzIiBoZWlnaHQ9IjE0LjUiIHJ4PSIyLjQ1MDAwMDA0NzY4MzcxNiIgZmlsbC1vcGFjaXR5PSIwIiBzdHJva2Utb3BhY2l0eT0iMSIgc3Ryb2tlPSIjOEE4Qzk5IiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEuNSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lite/icon/check_box_blank.svg
// module id = 1vul
// module chunks = 2